import { QContentStatusTag } from '@exam-management/components';
import { QuestionStatus, type QuestionGroup, QuestionGroupType } from '@exam-management/graphql';
import { EllipsisText, type GridColDef, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { QContentListRowMoreActionMenu, QContentQuestionTypeChip } from '../../components';

export interface Question {
  id: string;
  refCode: string;
  status: QuestionStatus;
  updatedAt: Date;
  questionGroup: Pick<QuestionGroup, 'id' | 'name' | 'type'> | null;
}

export const columns: GridColDef<Question>[] = [
  {
    field: 'refCode',
    headerName: 'QID',
    width: 200,
    sortable: false,
    renderCell: (params) => {
      return <Text variant='body2'>{params.value}</Text>;
    },
  },
  {
    field: 'questionGroup.name',
    headerName: 'QType',
    width: 128,
    sortable: false,
    renderCell: (params) => {
      const questionGroupType = params.row.questionGroup?.type;

      if (!questionGroupType) return null;

      return <QContentQuestionTypeChip type={questionGroupType} />;
    },
  },
  {
    field: 'questionGroup.type',
    headerName: 'Item Set/LOQ of',
    flex: 1,
    sortable: false,
    renderCell: (params) => {
      if (params.row.questionGroup?.type === QuestionGroupType.Single) return '-';

      return (
        <EllipsisText variant='body2Semibold'>
          {params.row.questionGroup ? params.row.questionGroup.name : '-'}
        </EllipsisText>
      );
    },
  },
  {
    field: 'updatedAt',
    headerName: 'Last Modified',
    width: 160,
    renderCell: (params) => {
      return <>{formatDateTime(params.value)}</>;
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    sortable: false,
    width: 120,
    renderCell: (params) => {
      const status = params.value as QuestionStatus;
      return <QContentStatusTag status={status} size='large' />;
    },
  },
  {
    field: 'moreAction',
    headerName: '',
    width: 36,
    sortable: false,
    renderCell: (params) => {
      const status = params.row.status as QuestionStatus;
      const isPreDraft = [
        QuestionStatus.InReview,
        QuestionStatus.InDevelopment,
        QuestionStatus.PreDraft,
      ].includes(status);
      const questionGroupId = params.row.questionGroup?.id ?? '';
      const questionGroupType = params.row.questionGroup?.type;
      const qId = params.row.refCode;
      const qContentId = params.row.id;

      if (!questionGroupType || isPreDraft) return null;
      return (
        <QContentListRowMoreActionMenu
          category={questionGroupType}
          status={params.row.status}
          qId={qId}
          qContentId={qContentId}
          groupId={questionGroupId}
          shouldRedirectTo='question'
        />
      );
    },
  },
];
